import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import TutorialWalkthroughButton from './TutorialWalkthroughButton';
import { TQBRenderFlag } from '../../../../models/purchase-history/quick-books-export';
import { IAlert } from '../../../../models/common';
import {
  pushPurchaseHistoryHeaderButtonEvent,
  setMoreThan390RecordsError,
} from '../../../../utils/purchase-history/analytics';
import { pushEventInfo } from '../../../../utils/analytics';

export interface IQuickBooksExportButton {
  isDesktopExport: boolean;
  setQBRenderFlag: (value: TQBRenderFlag) => void;
  setOpenModal: (value: boolean) => void;
  setAlertState: (value: IAlert | null) => void;
  qbCount?: number | undefined;
}

const warningMessage = `Warning! Please limit the number of transactions to 390 to export transactions to QuickBooks.
`;

const QuickBooksExportButton = (props: IQuickBooksExportButton) => {
  const {
    isDesktopExport,
    setQBRenderFlag,
    setOpenModal,
    qbCount,
    setAlertState,
  } = props;

  // const exportTypeName: string = isDesktopExport ? 'Desktop' : 'Online';

  const startQBExportAnalyticsClick = () => {
    // Analytics
    pushEventInfo({
      category: { primaryCategory: 'button submission' },
      eventInfo: { eventName: 'my account settings' },
      myAccount: { settings: 'purchase history: quickbooks start export' },
    });
  };

  return (
    <>
      <div
        className={`sui-flex ${
          isDesktopExport ? 'sui-justify-evenly' : 'sui-justify-center'
        } sui-mx-5 sui-py-3`}
      >
        {isDesktopExport && (
          <TutorialWalkthroughButton setQBRenderFlag={setQBRenderFlag} />
        )}
        <Button
          variant="secondary"
          fullWidth
          onClick={() => {
            startQBExportAnalyticsClick();
            if (qbCount && qbCount >= 390) {
              setMoreThan390RecordsError();
              setAlertState({
                status: 'warning',
                alertMessage: warningMessage,
                onClose: () => setAlertState(null),
              });
              setOpenModal(false);
            }
            if (isDesktopExport) {
              pushPurchaseHistoryHeaderButtonEvent('desktop');
              setQBRenderFlag('desktop');
            }
            if (qbCount && qbCount < 390) {
              pushPurchaseHistoryHeaderButtonEvent('online');
              setQBRenderFlag('online');
            }
          }}
        >
          Start Export
        </Button>
      </div>
    </>
  );
};

export default QuickBooksExportButton;
